import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
function SvgQrCode(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1.5em"
      height="1.5em"
      fill="none"
      viewBox="0 0 32 32"
      ref={ref}
      {...props}
    >
      <path
        fill="currentColor"
        d="M6.08325 7.33331C6.08325 6.64296 6.6429 6.08331 7.33325 6.08331H8.7777C9.46805 6.08331 10.0277 6.64296 10.0277 7.33331V8.77776C10.0277 9.46811 9.46805 10.0278 8.7777 10.0278H7.33325C6.6429 10.0278 6.08325 9.46811 6.08325 8.77776V7.33331Z"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M1.75 3C1.75 2.30964 2.30964 1.75 3 1.75L13.1111 1.75C13.8015 1.75 14.3611 2.30964 14.3611 3L14.3611 13.1111C14.3611 13.8015 13.8015 14.3611 13.1111 14.3611L3 14.3611C2.30964 14.3611 1.75 13.8015 1.75 13.1111L1.75 3ZM4.25 4.25L4.25 11.8611L11.8611 11.8611L11.8611 4.25L4.25 4.25Z"
        clipRule="evenodd"
      />
      <path
        fill="currentColor"
        d="M7.33325 21.972C6.6429 21.972 6.08325 22.5317 6.08325 23.222V24.6665C6.08325 25.3568 6.6429 25.9165 7.33325 25.9165H8.7777C9.46805 25.9165 10.0277 25.3568 10.0277 24.6665V23.222C10.0277 22.5317 9.46805 21.972 8.7777 21.972H7.33325Z"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M3 17.6387C2.30964 17.6387 1.75 18.1984 1.75 18.8887L1.75 28.9998C1.75 29.6902 2.30964 30.2498 3 30.2498L13.1111 30.2498C13.8015 30.2498 14.3611 29.6902 14.3611 28.9998V18.8887C14.3611 18.1984 13.8015 17.6387 13.1111 17.6387H3ZM4.25 27.7498V20.1387H11.8611V27.7498H4.25Z"
        clipRule="evenodd"
      />
      <path
        fill="currentColor"
        d="M21.9722 7.33331C21.9722 6.64296 22.5318 6.08331 23.2222 6.08331H24.6666C25.357 6.08331 25.9166 6.64296 25.9166 7.33331V8.77776C25.9166 9.46811 25.357 10.0278 24.6666 10.0278H23.2222C22.5318 10.0278 21.9722 9.46811 21.9722 8.77776V7.33331Z"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M17.6387 3C17.6387 2.30964 18.1983 1.75 18.8887 1.75L28.9998 1.75C29.6901 1.75 30.2498 2.30964 30.2498 3L30.2498 13.1111C30.2498 13.8015 29.6901 14.3611 28.9998 14.3611H18.8887C18.1983 14.3611 17.6387 13.8015 17.6387 13.1111V3ZM20.1387 4.25V11.8611H27.7498V4.25H20.1387Z"
        clipRule="evenodd"
      />
      <path
        fill="currentColor"
        d="M18.8887 17.6387C18.1983 17.6387 17.6387 18.1984 17.6387 18.8887V20.3332C17.6387 21.0235 18.1983 21.5832 18.8887 21.5832H20.3331C21.0235 21.5832 21.5831 21.0235 21.5831 20.3332V18.8887C21.5831 18.1984 21.0235 17.6387 20.3331 17.6387H18.8887Z"
      />
      <path
        fill="currentColor"
        d="M26.3054 18.8887C26.3054 18.1984 26.8651 17.6387 27.5554 17.6387H28.9999C29.6902 17.6387 30.2499 18.1984 30.2499 18.8887V20.3332C30.2499 21.0235 29.6902 21.5832 28.9999 21.5832H27.5554C26.8651 21.5832 26.3054 21.0235 26.3054 20.3332V18.8887Z"
      />
      <path
        fill="currentColor"
        d="M18.8887 26.3054C18.1983 26.3054 17.6387 26.865 17.6387 27.5554V28.9998C17.6387 29.6902 18.1983 30.2498 18.8887 30.2498H20.3331C21.0235 30.2498 21.5831 29.6902 21.5831 28.9998V27.5554C21.5831 26.865 21.0235 26.3054 20.3331 26.3054H18.8887Z"
      />
      <path
        fill="currentColor"
        d="M26.3054 27.5554C26.3054 26.865 26.8651 26.3054 27.5554 26.3054H28.9999C29.6902 26.3054 30.2499 26.865 30.2499 27.5554V28.9998C30.2499 29.6902 29.6902 30.2498 28.9999 30.2498H27.5554C26.8651 30.2498 26.3054 29.6902 26.3054 28.9998V27.5554Z"
      />
      <path
        fill="currentColor"
        d="M23.2222 21.972C22.5318 21.972 21.9722 22.5317 21.9722 23.222V24.6665C21.9722 25.3568 22.5318 25.9165 23.2222 25.9165H24.6666C25.357 25.9165 25.9166 25.3568 25.9166 24.6665V23.222C25.9166 22.5317 25.357 21.972 24.6666 21.972H23.2222Z"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgQrCode);
export default ForwardRef;
ForwardRef.defaultProps = {
  "aria-hidden": true,
  focusable: "false",
  role: "img",
};
